import Accordion from "./Accordion";
import Panel from "./Panel";

export default Accordion;

export {
    Panel
}
